import React from 'react'
import { Link } from 'react-router-dom'
import {
  Banknote,
  Building2,
  CheckCircle2,
  CircleHelp,
  Coins,
  Gift,
  Grid3X3,
  LogOut,
  Smile,
  User,
  UserPlus,
  Users,
  ChevronRight
} from 'lucide-react'
import { cn } from '../../lib/utils'

const ICONS = {
  'check-circle': CheckCircle2,
  coins: Coins,
  banknote: Banknote,
  user: User,
  contacts: UserPlus,
  smile: Smile,
  gift: Gift,
  bank: Building2,
  users: Users,
  grid: Grid3X3,
  help: CircleHelp,
  logout: LogOut
}

const AccountMenuItem = ({
  item,
  active = false,
  variant = 'list',
  onAction
}) => {
  const Icon = ICONS[item.icon] || User
  const showChevron = item.showChevron !== false && item.action !== 'logout'
  const isSidebar = variant === 'sidebar'

  const content = (
    <>
      <span className="flex min-w-0 items-center gap-4">
        <Icon
          className={cn(
            'size-5 shrink-0 transition-colors',
            active
              ? 'text-primary'
              : isSidebar
              ? 'text-secondary-foreground group-hover:text-primary'
              : 'text-secondary-foreground'
          )}
          strokeWidth={1.75}
        />
        <span
          className={cn(
            'truncate text-sm font-medium transition-colors',
            active
              ? 'text-primary'
              : isSidebar
              ? 'text-foreground group-hover:text-primary'
              : 'text-foreground'
          )}
        >
          {item.label}
        </span>
      </span>
      {showChevron && !isSidebar && (
        <ChevronRight className="account-interactive-chevron size-5 shrink-0 text-muted-foreground" />
      )}
    </>
  )

  const className = cn(
    'account-interactive-row group flex w-full cursor-pointer items-center justify-between text-left',
    isSidebar
      ? cn(
          'rounded-lg border px-3 py-2.5',
          active
            ? 'border-border bg-primary/10 text-primary hover:bg-primary/15'
            : 'border-transparent text-foreground hover:border-border hover:bg-primary/5'
        )
      : 'border-b border-border py-5 hover:bg-primary/5'
  )

  if (item.action) {
    return (
      <button
        type="button"
        className={cn(
          className,
          isSidebar &&
            item.action === 'logout' &&
            'justify-center border-primary bg-background text-center hover:bg-primary/10'
        )}
        onClick={() => onAction?.(item.action, item)}
      >
        {isSidebar && item.action === 'logout' ? (
          <span className="flex items-center gap-2">
            <Icon className="size-5 text-primary" strokeWidth={1.75} />
            <span className="text-sm font-semibold text-primary">
              {item.label}
            </span>
          </span>
        ) : (
          content
        )}
      </button>
    )
  }

  return (
    <Link to={item.to} className={className}>
      {content}
    </Link>
  )
}

export default AccountMenuItem
